import React, { useCallback, useEffect } from 'react';

import { ReportErrors } from '@jira/platform__error-reporting/src/ReportErrors.tsx';
import { ModalTransition } from '@atlaskit/modal-dialog';
import { useFlagsService } from '@atlassian/jira-flags';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { usePrevious } from '@atlassian/jira-platform-react-hooks-use-previous/src/common/utils/index.tsx';
import { useCurrentUser } from '@atlassian/jira-platform-services-user-current/src/main.tsx';
import { useRouterActions, useRouter } from '@atlassian/react-resource-router';
import { ERROR_REPORTING_PACKAGE, ERROR_REPORTING_TEAM } from '../common/constants.tsx';
import { useCreateSamplePlan, CreateSamplePlanProvider } from '../controllers/index.tsx';
import AsyncContent from './content/async.tsx';

const CreateSamplePlan = () => {
	const [{ isOpen }, { close }] = useCreateSamplePlan();
	const [{ location }] = useRouter();
	const initialLocation = usePrevious(location);

	// When the route changes we should close the modal
	useEffect(() => {
		if (initialLocation && initialLocation !== location) close();
	}, [close, initialLocation, location]);

	return (
		<ModalTransition>
			<Placeholder name="create-sample-plan" fallback={null}>
				{isOpen && <AsyncContent />}
			</Placeholder>
		</ModalTransition>
	);
};

const CreateSamplePlanContainer = ({ isOpen = false }: { isOpen?: boolean }) => {
	const { showFlag } = useFlagsService();
	const { push } = useRouterActions();
	const {
		data: { user: currentUser },
	} = useCurrentUser();

	const redirectToPlan = useCallback(
		(planId: number) => {
			push(`/jira/plans/${planId}`);
		},
		[push],
	);

	if (!currentUser.accountId) return null;

	return (
		<CreateSamplePlanProvider
			isGlobal
			isOpen={isOpen}
			showFlag={showFlag}
			redirectToPlan={redirectToPlan}
			leadAccountId={currentUser.accountId}
		>
			<ReportErrors
				id={ERROR_REPORTING_PACKAGE}
				packageName={ERROR_REPORTING_PACKAGE}
				teamName={ERROR_REPORTING_TEAM}
				sendToPrivacyUnsafeSplunk
			>
				<CreateSamplePlan />
			</ReportErrors>
		</CreateSamplePlanProvider>
	);
};
export default CreateSamplePlanContainer;
